import { useEffect, useState } from "react";

// @mui material components
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";
import MenuItem from "@mui/material/MenuItem";

// Material Dashboard 2 PRO React TS components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";

// Material Dashboard 2 PRO React TS examples components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";

import DashboardNavbar from "examples/Navbars/DashboardNavbar";
// Data
import { MemberService } from "service/member/service";
import {
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  InputLabel,
  ListItemText,
  Modal,
  OutlinedInput,
  Pagination,
  Radio,
  RadioGroup,
  Select,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import MDInput from "components/MDInput";
import { info } from "../promotion/data/dummyPromotionData";
import DataTable from "examples/Tables/DataTable";
import { paymentList } from "./data/dummyPaymentList";
import { PaymentService } from "service/payment/service";
import { TapasTwoTone } from "@mui/icons-material";

const getTodayDate = (daysOffset = 0) => {
  const today = new Date();
  today.setDate(today.getDate() + daysOffset);
  const yyyy = today.getFullYear();
  const mm = String(today.getMonth() + 1).padStart(2, "0");
  const dd = String(today.getDate()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd}`;
};

function Payment(): JSX.Element {
  const limit = 10;
  const [tableData, setTableData] = useState<any[]>([]);

  const [sortType, setSortType] = useState("CD");
  const [productType, setProductType] = useState(["A"]);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [totalPages, setTotalPages] = useState<number>(1);
  const [startDate, setStartDate] = useState("2025-01-01");
  const [endDate, setEndDate] = useState(getTodayDate());
  const [search, setSearch] = useState("");
  const [method, setMethod] = useState(0);

  const [modalOpen, setModalOpen] = useState(false);
  const [modalData, setModalData] = useState<any>(null);

  const [modalCurrentPage, setModalCurrentPage] = useState<number>(1);
  const [modalTotalPages, setModalTotalPages] = useState<number>(1);
  const [modalStartDate, setModalStartDate] = useState(getTodayDate(-7));
  const [modalEndDate, setModalEndDate] = useState(getTodayDate());

  const list = async (
    productType: string[],
    method: number,
    sort: string,
    search: string,
    startDate: string,
    endDate: string,
    limit: number,
    page: number
  ) => {
    try {
      const goodName = productType.includes("A") ? "" : productType.join(",");
      const res = await PaymentService.list(
        goodName,
        method,
        sort,
        search,
        startDate,
        endDate,
        limit,
        page
      );
      setTableData(res.list);
      setTotalPages(Math.ceil(res.totalCount / limit));
    } catch (err) {
      console.log(err);
    }
  };

  const detail = async (payId: string) => {
    try {
      const res = await PaymentService.detail(payId);

      setModalData(res);
    } catch (err) {
      console.log(err);
    }
  };

  const csv = async () => {
    try {
      const goodName = productType.includes("A") ? "" : productType.join(",");
      const a = document.createElement("a");
      a.href = `${process.env.REACT_APP_HOST}admin/csv3?startDate=${startDate}&endDate=${endDate}&goodName=${goodName}&search=${search}&sort=${sortType}`;
      a.download = "";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    } catch (err) {
      console.log(err);
    }
  };

  const handlePageChange = (event: React.ChangeEvent<unknown>, value: number) => {
    setCurrentPage(value);
  };

  const handleModalOpen = (payId: string) => {
    detail(payId);
    // setModalData({
    //   name: "김집고",
    //   sumPeriod: 700000,
    //   sumTotal: 700000,
    //   list: [
    //     {
    //       id: 1,
    //       name: "김집고",
    //       product: "전국얼리버드(50%)/1개월(스탠다드)",
    //       state: "결제완료",
    //       amount: 700000,
    //       paymentDate: "2024-08-25 14:16:26",
    //       paymentMethod: "신용카드",
    //       cancelDate: "",
    //       refundDate: "",
    //     },
    //     {
    //       id: 2,
    //       name: "김집고",
    //       product: "전국얼리버드(50%)/1개월(스탠다드)",
    //       state: "환불 완료",
    //       amount: 700000,
    //       paymentDate: "2024-08-25 14:16:26",
    //       paymentMethod: "신용카드",
    //       cancelDate: "",
    //       refundDate: "24-05-01 00:00:00",
    //     },
    //     {
    //       id: 3,
    //       name: "김집고",
    //       product: "전국얼리버드(50%)/1개월(스탠다드)",
    //       state: "결제취소 완료",
    //       amount: 700000,
    //       paymentDate: "2024-08-25 14:16:26",
    //       paymentMethod: "신용카드",
    //       cancelDate: "24-05-01 00:00:00",
    //       refundDate: "",
    //     },
    //     {
    //       id: 4,
    //       name: "김집고",
    //       product: "전국얼리버드(50%)/1개월(스탠다드)",
    //       state: "결제취소",
    //       amount: 700000,
    //       paymentDate: "2024-08-25 14:16:26",
    //       paymentMethod: "신용카드",
    //       cancelDate: "",
    //       refundDate: "",
    //     },
    //   ],
    // });
    // setModalTotalPages(3);
    setModalOpen(true);
  };

  useEffect(() => {
    setCurrentPage(1);
    list(productType, method, sortType, search, startDate, endDate, limit, currentPage);
  }, [productType, method, sortType, startDate, endDate]);

  useEffect(() => {
    list(productType, method, sortType, search, startDate, endDate, limit, currentPage);
  }, [currentPage]);

  return (
    <DashboardLayout>
      {modalOpen && modal(modalOpen, setModalOpen, modalData)}
      <DashboardNavbar />
      <MDBox my={3}>
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "end",
            gap: "16px",
            padding: "0 8px",
          }}
        >
          <div
            style={{
              padding: "8px",
              borderRadius: "8px",
              backgroundColor: "white",
              display: "flex",
              gap: "8px",
              alignItems: "center",
              fontSize: "14px",
              fontWeight: 500,
              border: "1px solid black",
              cursor: "pointer",
            }}
            onClick={csv}
            role="button"
          >
            <Icon>description</Icon>
            CSV 다운로드
          </div>
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              flexWrap: "wrap",
              gap: "8px",
            }}
          >
            <div
              style={{
                display: "flex",
                gap: "4px",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <span
                style={{
                  fontSize: "14px",
                  fontWeight: "600",
                  color: "#344676",
                  fontFamily: "Pretendard",
                }}
              >
                검색어
              </span>
              <input
                type="text"
                placeholder="상품명, 구매자명"
                style={{ padding: "8px" }}
                onChange={(e: any) => setSearch(e.target.value)}
              />
              <div
                style={{
                  padding: "8px",
                  backgroundColor: "rgb(30, 155, 107)",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontSize: "13px",
                  fontWeight: 600,
                  color: "white",
                  borderRadius: "8px",
                  width: "50px",
                  cursor: "pointer",
                }}
                onClick={() => {
                  setCurrentPage(1);
                  console.log(search);
                  list(
                    productType,
                    method,
                    sortType,
                    search,
                    startDate,
                    endDate,
                    limit,
                    limit * (currentPage - 1)
                  );
                }}
              >
                검색
              </div>
            </div>
            <div
              style={{
                display: "flex",
                gap: "4px",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <span
                style={{
                  fontSize: "14px",
                  fontWeight: "600",
                  color: "#344676",
                  fontFamily: "Pretendard",
                }}
              >
                상품명
              </span>
              <Select
                labelId="promotion-type-label"
                multiple
                variant="outlined"
                value={productType}
                onChange={(e) => {
                  let value = e.target.value as string[];

                  if (value.length === 0) {
                    setProductType(["A"]);
                    return;
                  }

                  if (value[value.length - 1] === "A") {
                    setProductType(["A"]);
                    return;
                  }
                  if (value.includes("A") && value.length > 1) {
                    setProductType(value.filter((v) => v !== "A"));
                    return;
                  }

                  setProductType(value.filter((v) => v !== "A"));
                  // setPromotionType(e.target.value as string[]);
                  console.log(productType);
                }}
                style={{
                  width: "150px",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  display: "block",
                }}
                sx={{
                  width: 150,
                  padding: "8px 0",
                  "& .MuiSelect-select": {
                    width: 120,
                    whiteSpace: "nowrap !important",
                    overflow: "hidden !important",
                    textOverflow: "ellipsis !important",
                    display: "block !important",
                    padding: 0,
                  },
                  "& .MuiSelect-icon": {
                    display: "block",
                  },
                }}
              >
                {productData.map((el) => (
                  <MenuItem key={el.value} value={el.value}>
                    {el.label}
                  </MenuItem>
                ))}
              </Select>
            </div>
            <div
              style={{
                display: "flex",
                gap: "4px",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <span
                style={{
                  fontSize: "14px",
                  fontWeight: "600",
                  color: "#344676",
                  fontFamily: "Pretendard",
                }}
              >
                결제 수단
              </span>
              <select
                name=""
                id=""
                style={{ padding: "8px" }}
                onChange={(e: any) => setMethod(e.target.value)}
              >
                {paymentMethodData.map((el, index) => (
                  <option value={el.value} key={index}>
                    {el.label}
                  </option>
                ))}
              </select>
            </div>
            <div
              style={{
                display: "flex",
                gap: "4px",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <span
                style={{
                  fontSize: "14px",
                  fontWeight: "600",
                  color: "#344676",
                  fontFamily: "Pretendard",
                }}
              >
                정렬 기준
              </span>
              <select
                name=""
                id=""
                style={{ padding: "8px" }}
                onChange={(e: any) => setSortType(e.target.value)}
              >
                {sortData.map((el, index) => (
                  <option value={el.value} key={index}>
                    {el.label}
                  </option>
                ))}
              </select>
            </div>
            <div style={{ gap: "16px", display: "flex" }}>
              <div
                style={{
                  display: "flex",
                  gap: "4px",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <span
                  style={{
                    fontSize: "14px",
                    fontWeight: "600",
                    color: "#344676",
                    fontFamily: "Pretendard",
                  }}
                >
                  시작일 선택
                </span>
                <input
                  type="date"
                  value={startDate}
                  style={{ padding: "8px" }}
                  onChange={(e: any) => setStartDate(e.target.value)}
                />
              </div>
              <div
                style={{
                  display: "flex",
                  gap: "4px",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <span
                  style={{
                    fontSize: "14px",
                    fontWeight: "600",
                    color: "#344676",
                    fontFamily: "Pretendard",
                  }}
                >
                  종료일 선택
                </span>
                <input
                  type="date"
                  value={endDate}
                  style={{ padding: "8px" }}
                  onChange={(e: any) => setEndDate(e.target.value)}
                />
              </div>
            </div>
          </div>
        </div>
        <Card style={{ marginTop: "24px" }}>
          <div style={{ padding: "24px 16px" }}>
            <div style={{ overflowX: "auto" }}>
              <table style={{ minWidth: "1000px", width: "100%" }}>
                <thead>
                  <tr
                    style={{
                      fontSize: "14px",
                      width: "100%",
                      textAlign: "center",
                      marginBottom: "16px",
                      fontFamily: "Pretendard",
                    }}
                  >
                    <th>결제 일시</th>
                    <th>구매 상품</th>
                    <th>결제 상태</th>
                    <th>구매자명</th>
                    <th>결제액(원)</th>
                    <th>결제수단</th>
                  </tr>
                </thead>
                <tbody>
                  {tableData.map((el: any, idx) => (
                    <tr
                      key={idx}
                      style={{
                        fontSize: 12,
                        color: "#000000DE",
                        textAlign: "center",
                        fontFamily: "Pretendard",
                      }}
                    >
                      <td
                        style={{
                          borderBottom: "1px solid #0000001A",
                          padding: "16px 0",
                        }}
                      >
                        {el.created_at}
                      </td>
                      <td
                        style={{
                          borderBottom: "1px solid #0000001A",
                          padding: "16px 0",
                        }}
                      >
                        {el.good_name}
                      </td>
                      <td
                        style={{
                          borderBottom: "1px solid #0000001A",
                          padding: "16px 0",
                        }}
                      >
                        {el.status}
                        <br />
                        {el?.cancelDate && <span>({el?.cancelDate})</span>}
                        {el?.refundDate && <span>({el?.refundDate})</span>}
                      </td>
                      <td
                        style={{
                          borderBottom: "1px solid #0000001A",
                          padding: "16px 0",
                        }}
                      >
                        {el.name}
                        <button
                          style={{
                            border: "none",
                            paddingLeft: "6px",
                            background: "none",
                            color: "#1e9b6b",
                            fontWeight: "bold",
                            cursor: "pointer",
                          }}
                          onClick={() => handleModalOpen(el.pay_id)}
                        >
                          [상세]
                        </button>
                      </td>
                      <td
                        style={{
                          borderBottom: "1px solid #0000001A",
                          padding: "16px 0",
                        }}
                      >
                        {Number(el.amount).toLocaleString()}
                      </td>
                      <td
                        style={{
                          borderBottom: "1px solid #0000001A",
                          padding: "16px 0",
                        }}
                      >
                        {el.method}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div style={{ display: "flex", justifyContent: "center", marginTop: "24px" }}>
              <Pagination
                count={totalPages}
                page={currentPage}
                onChange={handlePageChange}
                color="secondary"
                sx={{
                  "& .MuiPaginationItem-root": {
                    "&.Mui-selected": {
                      backgroundColor: "#1e9b6b",
                      color: "white",
                    },
                    "&.Mui-selected:hover": {
                      backgroundColor: "#1e9b6b",
                    },
                  },
                }}
              />
            </div>
          </div>
        </Card>
      </MDBox>
    </DashboardLayout>
  );
}
export default Payment;

function modal(open: boolean, setOpen: any, data: any) {
  console.log(data);
  if (!data || typeof data !== "object") return <p>올바른 객체가 아닙니다.</p>;

  return (
    <Modal
      open={open}
      onClose={() => setOpen(false)}
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "32px",
        width: "100%",
      }}
    >
      <MDBox
        bgColor="white"
        p="50px 40px"
        borderRadius="16px"
        display="flex"
        flexDirection="column"
        gap="25px"
        position={"relative"}
        maxHeight="80vh" // 화면 높이의 80% 넘지 않도록 제한
        overflow="auto"
      >
        <Icon
          onClick={() => setOpen(false)}
          sx={{
            position: "absolute",
            top: 16,
            right: 16,
            cursor: "pointer",
            fontSize: 28,
            color: "#888",
            zIndex: 1,
          }}
        >
          close
        </Icon>
        {/* {data} */}
        <Table sx={{ width: 800, border: "1px solid #0000001A" }} size="small">
          <TableBody>
            {Object.entries(data).map(([key, value], idx) => (
              <TableRow key={idx}>
                <TableCell
                  sx={{
                    fontSize: 14,
                    fontWeight: 500,
                    border: "1px solid #0000001A",
                    fontFamily: "Pretendard",
                    backgroundColor: "#F5F5F5",
                    minWidth: "150px",
                  }}
                >
                  {key}
                </TableCell>
                <TableCell
                  sx={{
                    fontSize: 14,
                    border: "1px solid #0000001A",
                    fontFamily: "Pretendard",
                    wordBreak: "break-all",
                  }}
                >
                  {typeof value === "object" && value !== null
                    ? JSON.stringify(value)
                    : String(value)}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </MDBox>
    </Modal>
  );
}

const sortData = [
  { label: "최신순", value: "CD" },
  { label: "오래된순", value: "CA" },
];

const productData = [
  { value: "A", label: "전체" },
  { value: "얼리버드", label: "얼리버드(50%)" },
];

const paymentMethodData = [
  { value: 0, label: "전체" },
  { value: 1, label: "신용카드" },
  { value: 2, label: "실시간 계좌이체" },
  { value: 3, label: "가상계좌" },
];
